<script lang="ts">
  import Testimonial from '$components/testimonial.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import type { LeftAlignedTextSectionStoryblok } from '$types/bloks';
  import Images from './marketing-sub-blocks/images.svelte';
  import ResponsiveImage from './marketing-sub-blocks/responsive-image.svelte';
  import SingleProduct from './marketing-sub-blocks/single-product.svelte';
  import Text from './marketing-sub-blocks/text.svelte';
  import Video from './marketing-sub-blocks/video.svelte';

  export let block: LeftAlignedTextSectionStoryblok;
</script>

<section use:storyblokEditable={block} class="px-2 lg:px-8 !py-0">
  <div
    class={cn(
      'container mx-auto lg:flex lg:gap-[88px] xl:gap-[248px] pt-[88px] pb-2 lg:pb-8',
      block.images?.[0] && 'pb-0'
    )}
  >
    {#if block.text?.[0]}
      <div
        class={cn(
          'lg:max-w-[448px] lg:shrink-0 lg:flex lg:flex-col lg:gap-[150px] lg:justify-between',
          block.testimonial?.[0] && 'lg:min-h-[560px] lg:h-[560px]'
        )}
      >
        <Text block={block.text?.[0]} class="px-2 lg:px-0" />

        {#if block.testimonial?.[0]}
          <Testimonial block={block.testimonial?.[0]} class="hidden lg:block" />
        {/if}
      </div>
    {/if}

    <div class={cn('mt-8 lg:mt-0 w-full', block.testimonial?.[0] && 'lg:min-h-[560px]')}>
      {#each block.content as content}
        {#if content.component === 'image-row'}
          <div class="flex flex-col gap-2 lg:gap-4">
            {#each content.images as image}
              <ResponsiveImage
                {image}
                imgClass="h-full lg:max-h-[560px] lg:min-h-[560px] object-cover rounded-md aspect-[374/560] lg:aspect-[680/560]"
              />
            {/each}
          </div>
        {:else if content.component === 'video'}
          <div class="[&>*]:py-0">
            <Video {content} />
          </div>
        {:else if content.component === 'single-product'}
          <SingleProduct {content} />
        {/if}
      {/each}
    </div>

    {#if block.testimonial?.[0]}
      <Testimonial block={block.testimonial?.[0]} class="lg:hidden mt-8" />
    {/if}
  </div>

  {#if block.images?.[0]}
    <div class="container mx-auto">
      <Images content={block.images?.[0]} />
    </div>
  {/if}
</section>
